/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { BiX } from 'react-icons/bi'
import { Button, Modal } from '@mui/material'
import { Alerts, Loading, SelectRadio } from '../../Simple'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { LocalStorage } from '../../../services'
import { ChatContext } from '../../../contexts/ChatContext'
import RouterHook from '../../../contexts/RouterHook'
import moment from 'moment'
import { EmpresasContext } from '../../../contexts/EmpresasContext'

import './stylesMCP.css'

/* ---- Regras de negócio: ----
  1. A regra de cancelamento possui os seguintes atributos: porcentagemMulta, 
    permitirCancelamentoPosHorario e minutosAntecedencia
  2. Não é possível cancelar um pedido que pertença à um horário fixo
    a. Somente os gestores da quadra podem cancelar horários fixos. 
      Você pode entrar em contato com o gestor para solicitar o cancelamento.
  3. Se o usuário tentar cancelar antes de extrapolar minutosAntecedencia, 
    informa que estorno será total
    a. Você ainda tem retornaMinutagem(this.retornaTempoRestanteCancelamento(dataInicio, minutosAntecedencia)) para cancelar gratuitamente. O estorno será de R$valorRealizado e acontecerá automaticamente.
  4. Se o usuário tentar cancelar após extrapolar minutosAntecedencia, e 
    permitirCancelamentoPosHorario == false, informa que não será possível cancelar.
    a. O período para cancelamento já passou. Não é mais possível cancelar! Se necessário, 
      entre em contato com o gestor solicitando o cancelamento.
  5. Se o usuário tentar cancelar após extrapolar minutosAntecedencia e 
    permitirCancelamentoPosHorario == true, informa ao usuário que ele irá pagar uma multa 
    de R$X,XX devido ao atraso no cancelamento, que é calculado usando o porcentagemMulta.
    a. O período para cancelamento sem custo já passou, se você cancelar, é cobrado 
      porcentagemMulta% (R$(valorTotal - valorDesconto) * porcentagemMulta) / 100) 
      do valor total do agendamento em virtude do atraso.
  6. Se o usuário tentar cancelar após extrapolar minutosAntecedencia e 
    permitirCancelamentoPosHorario == true, e porcentagemMulta == 0, informa que 
    a regra de cancelamento foi infringida, mas não será cobrada nenhuma multa.
    a. O período para cancelamento sem custo já passou, mas essa empresa não cobra multa.
  7. Se o pagamento for do tipo SINAL e permitirCancelamentoPosHorario == true, informa que 
    será possível cancelar mas o valor do sinal ficará retido como multa.
    a. O período para cancelamento sem custo já passou. O valor de R$valorRealizado pago como 
      sinal do agendamento ficará retido devido à esse cancelamento
*/

export default function CancelarPedido() {
  const serverRouter = RouterHook()
  const { userUCtx } = React.useContext(UsuarioContext)
  const { actionsChatCtx, sttChatCtx } = React.useContext(ChatContext)
  const { sttCtxAgend, loadAgend, modaisAgend, actionsAgend } = React.useContext(AgendamentoContext)
  const { actionsCtxEmps, getCurrentDay } = React.useContext(EmpresasContext) // <-- pegamos getCurrentDay

  const regra = sttCtxAgend.pedido.regraCancelamento
  const tempoRestante = retornaTempoRestanteCancelamento(
    sttCtxAgend.pedido.dataInicio,
    regra?.minutosAntecedencia,
  )
  const valorMulta =
    ((sttCtxAgend.pedido.valorTotal - sttCtxAgend.pedido.valorDesconto) * regra?.porcentagemMulta) /
    100
  const [motivo, setMotivo] = React.useState('')
  const [stt, setStt] = React.useState({ op: null, libera: false })

  const pagamentoLocal =
    sttCtxAgend.pedido.formaPagamento === 'DINHEIRO' ||
    sttCtxAgend.pedido.formaPagamento === 'LOCAL' ||
    sttCtxAgend.pedido.formaPagamento === 'MAQUINA_CARTAO'

  const regraCancelamentoAtiva = regra?.estaAtiva === 1
  const minutosAntecedencia = regra?.minutosAntecedencia || 0

  // ⬇️ Aqui, trocamos moment() por getCurrentDay() ⬇️
  const podeReagendar =
    moment(sttCtxAgend.pedido.dataInicio).diff(getCurrentDay(), 'minutes') >= minutosAntecedencia

  const reagendavel =
    (sttCtxAgend.pedido.status === 'AGENDADO' || sttCtxAgend.pedido.status === 'SOLICITADO') &&
    ((regraCancelamentoAtiva && podeReagendar) || !regraCancelamentoAtiva)

  async function handleReagendar() {
    Alerts.question(
      'Deseja reagendar este horário?',
      sttCtxAgend.pedido.status === 'AGENDADO' &&
        pagamentoLocal &&
        !sttCtxAgend.pedido.mensalista_idmensalista
        ? 'O novo horário precisará ser aprovado pelo gestor da quadra.'
        : 'Você conseguirá reagendar até 2 vezes, dentro de no máximo 30 dias.',
      () => {
        actionsAgend.ReagendarAgendamento()
        actionsCtxEmps.SelectEmpresa(sttCtxAgend.pedido.empresa)
        // aqui também setamos selectedDay com base no agendamento
        actionsCtxEmps.handleSttPg('selectedDay', moment(sttCtxAgend.pedido.dataInicio))
        serverRouter('centro-esportivo', sttCtxAgend.pedido.empresa.username)
      },
    )
  }

  const opcoes = [
    'Não consegui montar um time',
    'Tenho um compromisso neste horário',
    'Não agendei este horário',
    'Quero escolher outro horário',
    'Outro motivo',
  ]

  React.useEffect(() => {
    if (
      sttCtxAgend.pedido.regraCancelamento === null &&
      sttCtxAgend.pedido.regraCancelamento_idregraCancelamento !== null
    ) {
      console.error('Regra de cancelamento não encontrada.')
    } else {
      actionsAgend.handleLoadAgend('cancelamento', false)
    }
  }, [])

  async function ChamaCancelPedido(motivo) {
    if (stt.op === 4) {
      if (motivo.length < 5) {
        Alerts.swal(
          'warning',
          'Atenção',
          'Você deve informar um motivo para cancelar o agendamento.',
        )
        return false
      }
    }
    setStt({ ...stt, loading: true })

    if (stt.op === 4) await actionsAgend.CancelarAgendamento(motivo)
    else await actionsAgend.CancelarAgendamento(opcoes[stt.op])
    ClosedModal()
    setStt({ ...stt, loading: false })
  }

  function GoChat() {
    if (sttChatCtx.modeChat !== 'diretos') actionsChatCtx.handleModeChat('diretos')
    LocalStorage.set('chat-selected', { mode: 'diretos', id: sttCtxAgend.pedido.empresa_idempresa })
    serverRouter('chat', userUCtx.usuario.idusuario)
  }

  // ⬇️ Também trocamos moment() por getCurrentDay() aqui ⬇️
  function retornaTempoRestanteCancelamento(dataInicio, minutosAntecedencia) {
    return moment(dataInicio).diff(getCurrentDay(), 'minutes') - minutosAntecedencia
  }

  function ClosedModal() {
    actionsAgend.handleModaisAgend('cancelamento', false)
  }

  return (
    <Modal
      open={modaisAgend.cancelamento}
      onClose={ClosedModal}
      className='contain-overlay-modal-cancel-pedido'
    >
      <div className='contain-content-modal-cancel-pedido'>
        <BiX className='btt-closed-x' onClick={() => ClosedModal()} color='#ff7043' />
        <div className='contain-modal-cancel-pedido'>
          {loadAgend.cancelamento ? (
            <div className='contain-loading'>
              <Loading
                text={
                  'Aguarde, estamos cancelando seu agendamento, isso pode levar alguns segundos...'
                }
              />
            </div>
          ) : sttCtxAgend.pedido.mensalista_idmensalista !== null ? (
            <>
              <h2>Você não tem permissão para cancelar esse agendamento</h2>
              <p>
                Somente gestores têm permissão para cancelar um agendamento com horário fixo. Caso
                queira prosseguir, entre em contato com a quadra para solicitar o cancelamento.
              </p>
              <Button
                fullWidth
                variant='contained'
                sx={{ marginTop: '10px', fontSize: '16px' }}
                onClick={() => {
                  GoChat()
                }}
              >
                Falar com o Gestor
              </Button>
            </>
          ) : tempoRestante > 0 ? (
            <>
              <h2>Tem certeza que deseja cancelar seu agendamento?</h2>
              <p>
                Para efetuar o cancelamento, selecione um dos motivos abaixo e clique em confirmar.
              </p>
              <div className='contain-modal-formulario'>
                {opcoes.map((opcao, index) => {
                  return (
                    <SelectRadio
                      key={index}
                      textA={opcao}
                      textB={''}
                      select={stt.op === index}
                      onClick={() => {
                        if (stt.op === index) setStt({ ...stt, op: null })
                        else setStt({ ...stt, op: index })
                      }}
                    />
                  )
                })}
                {stt.op === 4 && (
                  <div className='contain-modal-qual-pedido'>
                    <h3>Qual o motivo?</h3>
                    <textarea
                      value={motivo}
                      onChange={e => {
                        setMotivo(e.target.value)
                      }}
                    />
                  </div>
                )}
              </div>
              <Button
                fullWidth
                variant='contained'
                sx={{ marginTop: '10px', fontSize: '16px', backgroundColor: '#f05746' }}
                disabled={stt.op === null || (stt.op === 4 && motivo.length < 4)}
                onClick={() => {
                  ChamaCancelPedido(motivo)
                }}
              >
                {stt.op === null
                  ? 'Selecione um motivo'
                  : stt.op === 4 && motivo.length < 4
                    ? 'Informe um motivo'
                    : 'Confirmar Cancelamento'}
              </Button>
              {reagendavel && (
                <Button
                  fullWidth
                  variant='contained'
                  sx={{ marginTop: '10px', fontSize: '16px', backgroundColor: '#ff7043' }}
                  onClick={() => {
                    handleReagendar()
                  }}
                >
                  Ou reagende o horário
                </Button>
              )}
            </>
          ) : !regra.permitirCancelamentoPosHorario ? (
            <>
              <h2>Não é possível cancelar o agendamento</h2>
              <p>O período de cancelamento desse agendamento expirou</p>
              <Button
                fullWidth
                variant='contained'
                sx={{ marginTop: '10px', fontSize: '16px' }}
                onClick={() => {
                  GoChat()
                }}
              >
                Falar com o Gestor
              </Button>
            </>
          ) : sttCtxAgend.pedido.formaPagamento === 'PIX' ||
            sttCtxAgend.pedido.formaPagamento === 'CARTAO_CREDITO' ? (
            <>
              <h2>Tem certeza que deseja cancelar seu agendamento?</h2>
              <p>{`O período para cancelamento sem custo já passou. O valor de R$${
                sttCtxAgend.pedido.valorRealizado === null
                  ? '0,00'
                  : sttCtxAgend.pedido.valorRealizado.toFixed(2).replace('.', ',')
              } pago como sinal do agendamento ficará retido devido a esse cancelamento.`}</p>
              <div className='contain-modal-formulario'>
                {opcoes.map((opcao, index) => {
                  return (
                    <SelectRadio
                      key={index}
                      textA={opcao}
                      textB={''}
                      select={stt.op === index}
                      onClick={() => {
                        if (stt.op === index) setStt({ ...stt, op: null })
                        else setStt({ ...stt, op: index })
                      }}
                    />
                  )
                })}
                {stt.op === 4 && (
                  <div className='contain-modal-qual-pedido'>
                    <h3>Qual o motivo?</h3>
                    <textarea
                      value={motivo}
                      onChange={e => {
                        setMotivo(e.target.value)
                      }}
                    />
                  </div>
                )}
              </div>
              <Button
                fullWidth
                variant='contained'
                sx={{ marginTop: '10px', fontSize: '16px', backgroundColor: '#f05746' }}
                disabled={stt.op === null || (stt.op === 4 && motivo.length < 4)}
                onClick={() => {
                  ChamaCancelPedido(motivo)
                }}
              >
                {stt.op === null
                  ? 'Selecione um motivo'
                  : stt.op === 4 && motivo.length < 4
                    ? 'Informe um motivo'
                    : 'Confirmar Cancelamento'}
              </Button>
            </>
          ) : regra.porcentagemMulta === 0 ? (
            <>
              <h2>Tem certeza que deseja cancelar seu agendamento?</h2>
              <p>
                O período para cancelamento sem custo já passou, mas essa empresa não cobra multa.
              </p>
              <div className='contain-modal-formulario'>
                {opcoes.map((opcao, index) => {
                  return (
                    <SelectRadio
                      key={index}
                      textA={opcao}
                      textB={''}
                      select={stt.op === index}
                      onClick={() => {
                        if (stt.op === index) setStt({ ...stt, op: null })
                        else setStt({ ...stt, op: index })
                      }}
                    />
                  )
                })}
                {stt.op === 4 && (
                  <div className='contain-modal-qual-pedido'>
                    <h3>Qual o motivo?</h3>
                    <textarea
                      value={motivo}
                      onChange={e => {
                        setMotivo(e.target.value)
                      }}
                    />
                  </div>
                )}
              </div>
              <Button
                fullWidth
                variant='contained'
                sx={{ marginTop: '10px', fontSize: '16px', backgroundColor: '#f05746' }}
                disabled={stt.op === null || (stt.op === 4 && motivo.length < 4)}
                onClick={() => {
                  ChamaCancelPedido(motivo)
                }}
              >
                {stt.op === null
                  ? 'Selecione um motivo'
                  : stt.op === 4 && motivo.length < 4
                    ? 'Informe um motivo'
                    : 'Confirmar Cancelamento'}
              </Button>
            </>
          ) : sttCtxAgend.pedido.formaPagamento === 'DINHEIRO' ||
            sttCtxAgend.pedido.formaPagamento === 'MAQUINA_CARTAO' ? (
            <>
              <h2>Tem certeza que deseja cancelar seu agendamento?</h2>
              <p
                style={{ marginBottom: '0px' }}
              >{`O período para cancelamento sem custo já passou. Se você cancelar, será cobrado ${
                regra.porcentagemMulta
              }% (R$${valorMulta.toFixed(2).replace('.', ',')}) do valor total do agendamento em virtude do atraso.`}</p>
              <p>{`Como o pagamento seria no local, entre em contato com o Gestor da quadra para efetuar o pagamento da multa.`}</p>
              <div className='contain-modal-formulario'>
                {opcoes.map((opcao, index) => {
                  return (
                    <SelectRadio
                      key={index}
                      textA={opcao}
                      textB={''}
                      select={stt.op === index}
                      onClick={() => {
                        if (stt.op === index) setStt({ ...stt, op: null })
                        else setStt({ ...stt, op: index })
                      }}
                    />
                  )
                })}
                {stt.op === 4 && (
                  <div className='contain-modal-qual-pedido'>
                    <h3>Qual o motivo?</h3>
                    <textarea
                      value={motivo}
                      onChange={e => {
                        setMotivo(e.target.value)
                      }}
                    />
                  </div>
                )}
              </div>
              <Button
                fullWidth
                variant='contained'
                sx={{ marginTop: '10px', fontSize: '16px', backgroundColor: '#f05746' }}
                disabled={stt.op === null || (stt.op === 4 && motivo.length < 4)}
                onClick={() => {
                  ChamaCancelPedido(motivo)
                }}
              >
                {stt.op === null
                  ? 'Selecione um motivo'
                  : stt.op === 4 && motivo.length < 4
                    ? 'Informe um motivo'
                    : 'Confirmar Cancelamento'}
              </Button>
            </>
          ) : (
            regra.permitirCancelamentoPosHorario && <></>
          )}
        </div>
      </div>
    </Modal>
  )
}
